import { useTile } from "web/hooks/data"

export default function TileSettings({
  close,
  isTemplate,
  overview,
  resetSelectedTileHandler,
  showBackButton,
  subjectType,
  subjectId,
  tileSettingsComponent: TileSettingsComponent,
  tileFetchParams,
}) {
  const backButtonHandler = () => {
    resetSelectedTileHandler(tile)
  }

  const tile = useTile({
    tileFetchParams,
  })

  const tileEntry = overview.tiles.find((item) => {
    // [TODO] This condition is temporary for backward compatibility
    if (isTemplate) {
      return item.entryable_id === tileFetchParams.id
    } else {
      return item.index === tileFetchParams.id
    }
  })

  return (
    <TileSettingsComponent
      backButtonHandler={showBackButton && backButtonHandler}
      close={close}
      isTemplate={isTemplate}
      overview={overview}
      subjectType={subjectType}
      subjectId={subjectId}
      tile={tile}
      tileEntry={tileEntry}
    />
  )
}
